import React from 'react'

const TotalStudentsIcon = () => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_7912)">
        <path
          d="M9.44264 0C9.74035 0.103857 10.0455 0.156383 10.2956 0.3062C13.0576 1.96195 15.8086 3.63799 18.5711 5.29314C18.9486 5.51936 18.9824 6.04044 18.5694 6.28755C15.8143 7.94091 13.0673 9.60979 10.3157 11.2691C9.70478 11.6374 9.10019 11.5914 8.49388 11.2232C6.13403 9.78945 3.76902 8.3647 1.40573 6.93636C1.04148 6.71611 0.675516 6.49944 0.313566 6.27621C-0.104599 6.01835 -0.105746 5.55816 0.313566 5.30448C3.07724 3.63322 5.83919 1.96016 8.60918 0.300231C8.85354 0.153995 9.15067 0.102067 9.44207 0H9.44264Z"
          fill="#434343"
        />
        <path
          d="M3.10614 9.20372C3.19447 9.25267 3.257 9.2843 3.31608 9.32011C4.8614 10.2542 6.40901 11.1836 7.95031 12.1249C8.94897 12.7349 9.93501 12.7385 10.9343 12.1296C12.4767 11.1901 14.0237 10.2602 15.5691 9.32668C15.6293 9.29027 15.6918 9.25864 15.7733 9.21268C15.7784 9.29922 15.7853 9.36309 15.7853 9.42636C15.7859 10.2232 15.7836 11.0194 15.7865 11.8163C15.7887 12.5039 15.5002 13.016 14.9329 13.3586C13.8012 14.0414 12.674 14.7326 11.5325 15.397C10.1243 16.2171 8.70576 16.1956 7.30557 15.3677C6.18702 14.7064 5.07765 14.0283 3.96254 13.3592C3.39237 13.0172 3.10327 12.5087 3.10499 11.821C3.10728 11.0242 3.10499 10.228 3.10499 9.43113C3.10499 9.36607 3.10499 9.30101 3.10499 9.20312L3.10614 9.20372Z"
          fill="#434343"
        />
        <path
          d="M18.7821 7.38379V7.6685C18.7821 9.31351 18.7832 10.9591 18.7798 12.6041C18.7798 12.7456 18.809 12.8464 18.9163 12.9509C19.3734 13.3956 19.3723 14.1327 18.9283 14.5864C18.4947 15.0298 17.7857 15.0179 17.3664 14.5613C16.9442 14.1011 16.958 13.3699 17.4105 12.9402C17.5126 12.8435 17.5436 12.7503 17.5436 12.6155C17.5402 11.1859 17.5436 9.75699 17.5379 8.32746C17.5373 8.18182 17.5769 8.10124 17.7002 8.03081C18.0507 7.83205 18.3931 7.61777 18.7815 7.38379H18.7821Z"
          fill="#434343"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_7912">
          <rect width="19.2603" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default TotalStudentsIcon
